// 开票 接口管理
import request from '../request.js'

// 开票-开票信息设置分页查询 --- 刘献根
export const getInvoiceInfoList = function(data) {
    return request({
        url: '/bmInvoice/getInvoiceInfoList',
        method: 'post',
        data
    })
}

// 开票-根据id查询明细 --- 刘献根
export const getInvoiceInfoById = function(data) {
    return request({
        url: '/bmInvoice/getInvoiceInfoById',
        method: 'post',
        data
    })
}

// 开票-新增-获取纳税人名称 --- 刘献根
export const getTenantSnameList = function(data) {
    return request({
        url: '/bmInvoice/getTenantSnameList',
        method: 'post',
        data
    })
}

// 开票-开票信息设置新增、修改、逻辑删除 --- 刘献根
export const saveInvoiceInfo = function(data) {
    return request({
        url: '/bmInvoice/saveInvoiceInfo',
        method: 'post',
        data
    })
}

// 开票-开票信息设置获取税率 --- 刘献根
export const getCascadeByValue = function(data) {
    return request({
        url: '/bmInvoice/getCascadeByValue',
        method: 'post',
        data
    })
}

// 开票-开票信息设置获取经营范围 --- 刘献根
export const getBusScopeTreeList = function(data) {
    return request({
        url: 'bmInvoice/getBusScopeTreeList',
        method: 'post',
        data
    })
}

// 开票-开票记录分页列表 --- 朱新宇
export const getInvoiceInfoRecordList = function(data) {
    return request({
        url: 'bmInvoice/getInvoiceInfoRecordList',
        method: 'post',
        data
    })
}

// 开票-开票记录--详情  --- 刘献根
export const getInvoiceInfoRecordInfo = function(data) {
    return request({
        url: 'bmInvoice/getInvoiceInfoRecordInfo',
        method: 'post',
        data
    })
}

// 开票-开票记录--查看发票  --- 刘献根
export const getCheckEleInvoice = function(data) {
    return request({
        url: 'bmInvoice/getCheckEleInvoice',
        method: 'post',
        data
    })
}

// 开票-开票记录--不通过  --- 俞祥东
export const rejectTaxInvoicingApply = function (data) {
    return request({
        url: 'optSysApplyRecord/rejectTaxInvoicingApply',
        method: 'post',
        data
    })
}

// 审核通过/审核不通过  --- 赵建强
export const auditSubmit = function (data) {
    return request({
        url: 'applyRecord/auditSubmit',
        method: 'post',
        data
    })
}

// 开票分页-开票 --- 刘志争
export const reissueInvoice = function (data) {
    return request({
        url: 'bmInvoice/reissueInvoice',
        method: 'post',
        data
    })
}

// 开票分页-线下开票 --- 刘志争
export const physicalInvoice = function (data) {
    return request({
        url: 'bmInvoice/physicalInvoice',
        method: 'post',
        data
    })
}


// 开票分页-红冲 --- 刘志争
export const applyRedInkInvoice = function (data) {
    return request({
        url: '/bmInvoice/applyRedInkInvoice',
        method: 'post',
        data
    })
}

// 线下开票-详情 --- 朱新宇
export const physicalInvoiceDetail = function (data) {
    return request({
        url: '/bmInvoice/physicalInvoiceDetail',
        method: 'post',
        data
    })
}


